export class ChangeOrderHanding {
    public id: number;
    public changeOrderId: number;
    public handing: string;
    public action: string;
}